import { Phone, Mail, MapPin } from "lucide-react";
import { Eyebrow, FadeUp, MaskLines } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";
import { EMAIL, PHONE } from "@/data/content";

export const ContactBlock = ({ asH1 = false }) => (
  <section id="enquiry" data-testid="contact-section" className="bg-[#F8FAFC] py-24 md:py-36 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Eyebrow>Care enquiry</Eyebrow>
        <MaskLines as={asH1 ? "h1" : "h2"} className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.04em] leading-[0.95] text-[#0A192F]"
          lines={["Tell us what", <>you <span className="font-serif-i font-normal tracking-normal text-sky-700">need.</span></>]} />
        <FadeUp delay={0.1}>
          <p className="mt-8 text-slate-600 text-base md:text-lg leading-relaxed max-w-md">Whether it's a shift tonight or care for a parent next month, a coordinator will call you back — usually within the hour.</p>
          <div className="mt-10 space-y-5">
            {[[Phone, PHONE, "contact-phone"], [Mail, EMAIL, "contact-email"], [MapPin, "[Office address], East Midlands", "contact-address"]].map(([Icon, v, id]) => (
              <p key={id} data-testid={id} className="flex items-center gap-4 text-[#0A192F] font-semibold">
                <span className="w-11 h-11 rounded-full bg-white border border-slate-200 grid place-items-center"><Icon size={18} className="text-sky-700" /></span>{v}
              </p>
            ))}
          </div>
        </FadeUp>
      </div>
      <FadeUp className="lg:col-span-7" delay={0.15}><EnquiryForm /></FadeUp>
    </div>
  </section>
);
